<mat-toolbar>
  <img src="meril.png" alt="Logo">
   &nbsp;<span> Tracker App</span>
  <!-- &nbsp;<button mat-button [routerLink]="['/home/dashboard']">Dashboard</button> -->
  &nbsp;<span><button mat-button *ngIf="newRoleId === RoleEnum.ADMIN || newRoleId === RoleEnum.TEAMLEAD || newRoleId === RoleEnum.DEPARTMENT_ADMIN" [routerLink]="['/home/user']">Users</button></span>
  &nbsp;<button mat-button [routerLink]="['/home/timesheet']">Timesheet</button>
  &nbsp;<button mat-button [routerLink]="['/home/timesheet-report']">Report</button>
  <!-- &nbsp;<span [hidden]="!isAdmin"><button mat-button [routerLink]="['/home/category']">Category</button></span> -->
  <span *ngIf="newRoleId === RoleEnum.ADMIN || newRoleId === RoleEnum.DEPARTMENT_ADMIN"><button mat-button [routerLink]="['/home/category']">Category</button></span>
  <!-- &nbsp;<span [hidden]="!isAdmin"><button mat-button [routerLink]="['/home/activity']">Activity</button></span> -->

  &nbsp;<span *ngIf="newRoleId === RoleEnum.ADMIN || newRoleId === RoleEnum.DEPARTMENT_ADMIN"><button mat-button [routerLink]="['/home/activity']">Activity</button></span>
  <span *ngIf="newRoleId === RoleEnum.EMPLOYEE || newRoleId === RoleEnum.TEAMLEAD || newRoleId === RoleEnum.DEPARTMENT_ADMIN || isHr"><button mat-button [routerLink]="['/home/recruitment']">Recruitment</button></span>
  @if(!isAdmin){
  <button mat-button [routerLink]="['/home/anonymous-feedback']">Anonymous Feedback</button>
  }
  @else{
    <button mat-button [routerLink]="['/home/anonymous-feedback/list']">Anonymous Feedback</button>
  }
  <span class="example-spacer"></span>
  <button mat-button (click)="playVideo()"><mat-icon>help</mat-icon>Help</button>
  <button mat-button [matMenuTriggerFor]="menu"><mat-icon>people</mat-icon> {{userName}}</button>
  <mat-menu #menu="matMenu">
    <section [hidden]="isSuperAdmin">
      <button mat-menu-item [hidden]="true" [routerLink]="['/home/changePassword']">
        <mat-icon>password</mat-icon>
        <span>Change Password</span>
      </button>
    </section>
    <button mat-menu-item (click)="onLogOut()">
      <mat-icon>logout</mat-icon>
      <span>Logout</span>
    </button>
  </mat-menu>
</mat-toolbar>
